import { useTranslation } from 'react-i18next';
import { Modal } from 'reactstrap';
import { useState, useEffect } from 'react';
import { classes } from './modalClasses'; // Assuming you have a similar styles object
import { Feedback } from '@mui/icons-material';
export const FeedbackModal = (props) => {
    const { t } = useTranslation();
    const [modalOpen, setModalOpen] = useState(false);

    const [feedbackArray, setFeedbackArray] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 5;

    const handleModalClose = () => {
        setModalOpen(false);
        setCurrentPage(1)
        props.handleClose();
    };
    useEffect(() => {
        if (props.open) {
            setModalOpen(true);
        }
    }, [props.open]);

    useEffect(() => {
        if (props.array) {
            const rows = props.array.map((item) => ({
                ...item,
                rowKey: `${item.netlinking.id}`,
                feedback: item.feedback ?? '',
                originalFeedback: item.feedback ?? null,
            }));

            setFeedbackArray(rows);
        }
    }, [props.array]);

    function updateCommantary(rowKey, value) {
        const sortedupdatedItems = feedbackArray.map((item) => {
            if (item.rowKey === rowKey) {
                return { ...item, feedback: value };
            }
            return item;
        });
        setFeedbackArray(sortedupdatedItems)
    }
    return (
        <Modal
            style={classes.superLargeModalCustom}
            isOpen={props.open}
            toggle={handleModalClose}
            backdrop={true}
            keyboard={false}
        >
            <div style={classes.modalHeader} className="modal-header">
                <h5 style={classes.title} className="modal-title">
                    {t('Commentaire')}
                </h5>
                <button
                    type="button"
                    onClick={handleModalClose}
                    style={classes.btnClose}
                    className="btn-close"
                    aria-label="Close"
                />
            </div>
            <div style={classes.modalPad} className="modal-body">
                <div className="row row-mb-lg">
                    <div className="col-12">
                        <p style={classes.textConfirm}>{t('Vos commentaires nous intéressent !')}</p>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center", // Centers horizontally
                        }}
                    >
                        <img
                            style={{
                                height: '150px'
                            }}
                            src="/Images/chicken/feedbackStress.gif"
                            alt="download icon"
                        />
                    </div>

                </div>
                <div className="table-responsive">
                    <div className="box-table-netlinking">
                        <table className="table-lists">
                            <thead>
                                <tr>
                                    <th>{t('Domaine')}</th>
                                    <th>{t('Commentaire')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {feedbackArray.slice(
                                    (currentPage - 1) * rowsPerPage,
                                    currentPage * rowsPerPage
                                ).map((item) => (
                                    <tr key={item.rowKey}>
                                        <td>{item.netlinking.domain}</td>
                                        <td>
                                            <textarea
                                                value={item.feedback}
                                                onChange={(e) => updateCommantary(item.rowKey, e.target.value)}
                                                placeholder={t('Commentaire') + item.netlinking.id}
                                                style={classes.textarea}
                                                className="form-control"
                                            /></td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                {Math.ceil(feedbackArray.length / rowsPerPage) > 1 && (
                    <div className="box-pagination">
                        {feedbackArray.length === 0 || currentPage === 1 ? (
                            <div style={{ cursor: 'not-allowed' }} className="text-page">
                                {t('Précédent')}
                            </div>
                        ) : (
                            <div
                                style={{ cursor: 'pointer' }}
                                onClick={() => setCurrentPage(currentPage - 1)}
                            >
                                {t('Précédent')}
                            </div>
                        )}

                        <div className="list-page-number">
                            <span
                                className={'active'}
                            >
                                {currentPage}
                            </span>
                            {feedbackArray.length === 0 ||
                                currentPage === Math.ceil(feedbackArray.length / 5) ? (
                                <span style={{ cursor: 'not-allowed' }} className="text-page">
                                    {t('Suivant')}
                                </span>
                            ) : (
                                <span onClick={() => setCurrentPage(currentPage + 1)}>
                                    {t('Suivant')}
                                </span>
                            )}
                        </div>
                    </div>
                )}
                <div className="d-flex justify-content-end mt-5">
                    <button
                        style={{ backgroundColor: '#43b929' }}
                        className="confirm"
                        onClick={() => {
                            // on ne renvoie que : une ligne "nouvelle" non vide, OU une ligne existante dont le texte a changé
                            const toSubmit = feedbackArray.filter((item) => {
                                const trimmed = (item.feedback ?? '').trim();
                                if (trimmed === '') return false;
                                if (item.originalFeedback === null) return true; // nouvelle ligne
                                return trimmed !== item.originalFeedback.trim(); // ligne modifiée
                            });
                            props.onSubmit(toSubmit);
                        }}
                    >

                        {t('Confirmer')}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default FeedbackModal;